import { SecurityContext } from 'auth/contexts/SecurityContext';
import { useContext, useEffect, useRef } from 'react';
import { FetcherService } from '../models/fetcher-service';
import { useNavigate } from 'react-router-dom';

export function useFetcherService() {
  const { accessToken, authenticate, clearTokens } = useContext(SecurityContext);
  const fetcherService = useRef<FetcherService>();
  const navigate = useNavigate();

  useEffect(() => {
    fetcherService.current.setup(accessToken, authenticate, navigate, clearTokens);
  }, [accessToken, authenticate, navigate, clearTokens]);

  const registerFetcherService = (f: FetcherService) => {
    fetcherService.current = f;
    fetcherService.current.setup(accessToken, authenticate, navigate, clearTokens);
  };

  return { registerFetcherService };
}
